import { useQuery } from '@tanstack/vue-query'
import { computed, unref, type MaybeRef } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { tryoutHomeAPI } from '@/api'

export const tryoutHomeQueryKey = (seasonId: string, tryoutId: string, clubId?: string) => [
  'tryoutHome',
  seasonId,
  tryoutId,
  clubId || '',
]

export function useTryoutHome(seasonId: MaybeRef<string>, tryoutId: MaybeRef<string>, clubId?: MaybeRef<string>) {
  const auth = useAuthStore()
  return useQuery({
    queryKey: computed(() => [...tryoutHomeQueryKey(unref(seasonId), unref(tryoutId), unref(clubId)), auth.user?.details?.id || auth.user?.id || '']),
    staleTime: 30000,
    gcTime: 0,
    queryFn: ({ signal }) => tryoutHomeAPI.loadHome(unref(seasonId), unref(tryoutId), unref(clubId), signal),
    enabled: computed(() => Boolean(unref(clubId) && unref(seasonId) && unref(tryoutId) && auth.user && !auth.switchingIdentity)),
  })
}
